import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AmendEvacDeviceProgressStepper from "./components/amendEVACDeviceProgressStepper"
import CoreEVACDeviceDetails from "./formPages/coreEVACDeviceDetails"
import ReviewAndSubmitEVACDevice from "./formPages/reviewAndSubmitEVACDevice"
import { AmendEVACDeviceContext } from "./providers/baseProviders/amendEVACDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { EVACDeviceFormData } from "../types/providerTypes"

/** The form for amending an EVAC device */
const AmendEVACDeviceForm = (): ReactElement => (
    <Stack spacing={GRID_SPACING}>
        <AppCard>
            <AppCardContent>
                <AmendEvacDeviceProgressStepper />
            </AppCardContent>
        </AppCard>

        <MultiPageForm context={AmendEVACDeviceContext}>
            <CoreEVACDeviceDetails context={AmendEVACDeviceContext} />
            <LctDeviceAttachments<EVACDeviceFormData>
                context={AmendEVACDeviceContext}
                dataset={Datasets.EVAC}
                isAmendment
            />
            <ReviewAndSubmitEVACDevice
                context={AmendEVACDeviceContext}
                isAmendment
            />
        </MultiPageForm>
    </Stack>
)

export default AmendEVACDeviceForm
